import { Menu, Sparkles, X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

interface MobileQuickLaunchButtonProps {
  onQuickLaunch: () => void;
}

export function MobileQuickLaunchButton({
  onQuickLaunch,
}: MobileQuickLaunchButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-7 shrink-0"
      onClick={onQuickLaunch}
      aria-label={t("quickLaunch.title")}
    >
      <Sparkles className="size-4" />
    </Button>
  );
}

interface MobileSessionMenuButtonProps {
  isMenuOpen: boolean;
  onMenuToggle: () => void;
}

export function MobileSessionMenuButton({
  isMenuOpen,
  onMenuToggle,
}: MobileSessionMenuButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-7 shrink-0"
      onClick={onMenuToggle}
      aria-label={isMenuOpen ? t("header.closeMenu") : t("header.openMenu")}
    >
      {isMenuOpen ? <X className="size-4" /> : <Menu className="size-4" />}
    </Button>
  );
}
